import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=4c4a2363&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=4c4a2363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a2363",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4a2363')) {
      api.createRecord('4c4a2363', component.options)
    } else {
      api.reload('4c4a2363', component.options)
    }
    module.hot.accept("./OrderItem.vue?vue&type=template&id=4c4a2363&scoped=true&", function () {
      api.rerender('4c4a2363', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/print/OrderItem.vue"
export default component.exports